export enum ToursSummaryTileType {
  Requested = 'requested',
  Booked = 'booked',
  Canceled = 'canceled',
}

export enum ToursSummaryDayChipType {
  Today = 'today',
  Tomorrow = 'tomorrow',
  DayAfterTomorrow = 'day_after_tomorrow',
}
